import './common.css';
import './images/logo.png';
import './images/none.jpg';
import './utils/passwort-input';


export const delay = (callback, ms) => {
  var timer = 0;
  return function () {
    var context = this, args = arguments;
    clearTimeout(timer);
    timer = setTimeout(function () {
      callback.apply(context, args);
    }, ms || 0);
  };
};

export const mergeObjects = (obj1, obj2) => {
  var obj3 = {};
  for (var attr1 in obj1) { obj3[attr1] = obj1[attr1]; }
  for (var attr2 in obj2) { obj3[attr2] = obj2[attr2]; }
  return obj3;
};

export const getParamValueByName = (name, url) => {
  name = name.replace(/[\[\]]/g, '\\$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
  var results = regex.exec(url);

  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

export const redirectToLogin = (anchor) => {
  var url = "/Account/Login?ReturnUrl=" + window.location.pathname + window.location.search;
  if (anchor) {
    url = url + "&anchor=" + anchor;
  }
  window.location.href = url;
}

export const removeFromArray = (array, value) => {
  var index = array.indexOf('' + value);
  if (index > -1) {
    array.splice(index, 1);
  }
}

export const changeSequenceSearchPath = (currentSearchPath, paramName, newValue, isRemove) => {
  var paramValue = getParamValueByName(paramName, currentSearchPath);
  var values = [];
  if (paramValue) {
    values = paramValue.split(',');
  }


  if (isRemove) {
    removeFromArray(values, newValue);
  } else {
    values.push(newValue);
  }

  if (paramValue) {
    var pattern = new RegExp(paramName + '=' + paramValue, 'i');
    var replace = '';
    if (values.length > 0)
      replace = paramName + '=' + values.join();
    currentSearchPath = currentSearchPath.replace(pattern, replace);
  } else {
    if (currentSearchPath && values.length > 0) {
      currentSearchPath = currentSearchPath + '&' + paramName + '=' + values.join();
    } else {
      currentSearchPath = '?' + paramName + '=' + values.join();
    }
  }

  currentSearchPath = currentSearchPath.replace(/^[?][&]/, '?');
  currentSearchPath = currentSearchPath.replace(/[?,&]$/, '');

  return currentSearchPath;
}

export const changeParamSearchPath = (currentSearchPath, paramName, newValue) => {
  var paramValue = getParamValueByName(paramName, currentSearchPath);
  var replace = paramName + '=' + newValue;

  if (paramValue) {
    var pattern = new RegExp(paramName + '=' + paramValue, 'i');
    currentSearchPath = currentSearchPath.replace(pattern, replace);
  } else {
    if (currentSearchPath) {
      currentSearchPath = currentSearchPath + '&' + replace;
    } else {
      currentSearchPath = '?' + replace;
    }
  }

  currentSearchPath = currentSearchPath.replace(/^[?][&]/, '?');
  currentSearchPath = currentSearchPath.replace(/[?,&]$/, '');

  return currentSearchPath;
}

const dataAjaxFailure = (error) => {
  console.log('dataAjaxFailure', error);
  if (error.status === 401)
    redirectToLogin();
}


var navbar = document.getElementsByClassName("navbar-collapse")[0];
navbar.addEventListener("click", (event) => {
  event.stopPropagation();
});

var body = document.getElementsByTagName("body")[0];
body.addEventListener("click", () => {
  var btnNavbar = document.getElementsByClassName("navbar-toggler")[0];
  var opened = navbar.classList.contains("show");
  if (opened === true) {
    btnNavbar.click();
  }
});


window.dataAjaxFailure = dataAjaxFailure;